import React from 'react';
import { AxiosRequestConfig } from 'axios';
import ApiHandlerContext from './ApiHandlerContext';

interface Props {
  children: React.ReactNode;
  defaultConfig?: AxiosRequestConfig;
}

/**
 * This provider is complementary to the useRequest hook, and it allows you to
 * pass a default Axios configuration to be used in all requests.
 */
const ApiHandlerProvider = ({ children, defaultConfig }: Props) => {
  return (
    <ApiHandlerContext.Provider value={{ defaultConfig }}>
      {children}
    </ApiHandlerContext.Provider>
  );
};

export default ApiHandlerProvider;
